import { api } from "../../src/component/constent";


// ============================================================
// CURRENT QUARTER / YEAR
// ============================================================

export const getPOHOutternCurrentQuarter = () => {

    return api.get(
        "/entry/pohouttern/current-quarter"
    );

};


// ============================================================
// GET DATA
// ============================================================

export const getPOHOuttern = (
    quarter,
    year
) => {

    return api.get(
        "/entry/pohouttern",
        {
            params: {
                quarter,
                year
            }
        }
    );

};


// ============================================================
// SAVE
// CREATE / UPDATE
// ============================================================

export const savePOHOuttern = (
    data
) => {

    return api.post(
        "/entry/pohouttern",
        data
    );

};


// ============================================================
// DELETE
// ============================================================

export const deletePOHOuttern = (
    pohAllocation,
    pohType,
    quarter,
    year
) => {

    return api.delete(
        "/entry/pohouttern",
        {
            params: {

                pohAllocation,
                pohType,
                quarter,
                year

            }
        }
    );

};

// ============================================================
// UPDATE
// ============================================================

export const updatePOHOuttern = (
    data
) => {

    return api.put(
        "/entry/pohouttern",
        data
    );

};